import React from 'react';
import { Reveal } from './Reveal';
export function Proof() {
  return <section className="w-full bg-ink py-24" data-id="element-137">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-138">
        <Reveal data-id="element-139">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-rose-glow" data-id="element-140">
            Lo que puedes creer
          </p>
        </Reveal>
        <Reveal delay={0.05} data-id="element-141">
          <p className="mt-6 font-display text-2xl leading-relaxed text-cream sm:text-3xl" data-id="element-142">
            En los primeros <span className="text-electric" data-id="element-143">7 días</span>, el
            peso de la "obligación de entender" desaparece.
          </p>
        </Reveal>
        <Reveal delay={0.1} data-id="element-144">
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-145">
            No prometemos que esa persona volverá; prometemos que para cuando
            llegue el <span className="font-semibold text-cream" data-id="element-146">día 21</span>,
            ya no te importará si lo hace o no.
          </p>
        </Reveal>
        <Reveal delay={0.15} data-id="element-147">
          <p className="mt-8 font-display text-xl italic text-electric sm:text-2xl" data-id="element-148">
            Pasarás de la ansiedad del "visto" a la paz del silencio.
          </p>
        </Reveal>
      </div>
    </section>;
}